import React, { useState } from "react";

import { Clear } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, IconButton, Select, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import FilterFieldTitle from "root/features/Layouts/FilterFieldTitle";
import { setBloggersPostsParamByName } from "root/store/bloggersPosts";

import MenuItem_ from "root/components/MenuItem";
import Select_ from "root/components/Select";

//
export const yesNoSelectorOptions = [
  { id: "any", title: "Не важно", serverValue: undefined },
  { id: "yes", title: "Да", serverValue: true },
  { id: "no", title: "Нет", serverValue: false },
];
//
export default function YesOrNoSelector({
  dataIndex,
  title,
  tooltip,
  options = yesNoSelectorOptions,
  name,
}) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const currentValue = useSelector(s => s.bloggersPosts.params[dataIndex]);

  const onChange = e => dispatch(setBloggersPostsParamByName({ name, value: e.target.value }));

  const clearValue = e => {
    e.stopPropagation();
    dispatch(setBloggersPostsParamByName({ name, value: "" }));
  };

  return (
    <Box>
      <FilterFieldTitle {...{ dataIndex, title, tooltip }} />
      <Select
        fullWidth
        value={currentValue}
        displayEmpty
        onChange={onChange}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        sx={{
          paddingRight: "1rem",
          backgroundColor: currentValue ? "#eef4fa" : "#fff",
          "& .MuiSelect-icon": {
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease-in-out",
          },
        }}
        IconComponent={props => {
          if (currentValue) {
            return (
              <>
                <IconButton
                  size="small"
                  onClick={clearValue}
                  sx={{ position: "absolute", right: 15, zIndex: 1 }}>
                  <Clear />
                </IconButton>
              </>
            );
          }
          return <ArrowDropDownIcon {...props} />;
        }}>
        <MenuItem_ value="" disabled>
          <Typography>Выберите значение</Typography>
        </MenuItem_>
        {options.map(item => (
          <MenuItem_ key={item.id} value={item.id}>
            <Typography>{item.title}</Typography>
          </MenuItem_>
        ))}
      </Select>
    </Box>
  );
}
